import clsx from 'clsx';

export const checkboxClasses = clsx(
	'h-8',
	'w-8',
	'rounded-md',
	'text-forestGreen-700',
	'bg-transparent',
	'!outline-0',
	'!ring-forestGreen-700',
	'border-forestGreen-700',
	'active:shadow-focus',
	'cursor-pointer',
);

export const toggleClasses = clsx(
	'flex',
	'h-8',
	'w-8',
	'rounded-full',
	'border',
	'border-forestGreen-700',
	'hover:border-forestGreen-100',
	'hover:bg-forestGreen-100',
	'hover:cursor-pointer',
	'peer-checked:bg-forestGreen-700',
	'peer-checked:border-forestGreen-700',
	'peer-focus-visible:ring-2',
	'peer-focus-visible:ring-offset-2',
	'peer-focus-visible:ring-forestGreen-700',
	'transition-all',
	'duration-200',
);
